var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GekkoButton',{staticClass:"display-none",attrs:{"text":_vm.$gettext('Open wizard'),"variant":"link text-blue","icon":'fa-solid fa-sparkles',"icon-right":""},on:{"click":_vm.openOnboardingWizard}})}
var staticRenderFns = []

export { render, staticRenderFns }